import * as React from 'react';
import { Header1 } from '@cian/ui-kit';

import { Layout } from '../Layout';

import * as styles from './styles.css';

interface ILayoutWithHeaderProps {
  title: string;
}

export function LayoutWithHeader({ title, children }: React.PropsWithChildren<ILayoutWithHeaderProps>) {
  return (
    <Layout>
      <div className={styles['header']}>
        <Header1 as="h2" fontWeight="bold">
          {title}
        </Header1>
      </div>
      {children}
    </Layout>
  );
}
